import useSWR from "swr";
import actionsService from "../../services/actions.service";

const SWR_CACHE_KEY = "actionComments_";
const useActionComments = (actionId?: string | number) => {
    const { data, error, isLoading, mutate } = useSWR(
        SWR_CACHE_KEY + actionId,
        actionId ? () => actionsService.getActionComments(actionId) : null,
        {
            revalidateOnFocus: false,
            revalidateOnReconnect: false,
            refreshWhenHidden: false,
            refreshWhenOffline: false,
        }
    );

    const comments = data?.data;

    const mutateActionComment = (newActionCommentData: any, options = {}) =>
        mutate((actionCommentData: any) => {
            const actionCommentsClone = { ...actionCommentData };

            actionCommentsClone.data.push(newActionCommentData);

            return actionCommentsClone;
        }, options);

    return {
        comments,
        isLoading: isLoading || !comments,
        error,
        mutateActionComment,
    };
};

export default useActionComments;
